module.exports = __webpack_public_path__ + "static/media/flag-sl.4d40de03.webp";